import type {
  ApiResponse,
  ConversionRate,
  Country,
  UpdateConversionRateRequest
} from '../../types/ApiTypes';
import { apiManager } from '../api/ApiManager';

export class SystemService {
  async getCountries(): Promise<ApiResponse<Country[]>> {
    return apiManager.get<Country[]>('/api/v1/admin/countries');
  }

  async getDollarConversionRate(): Promise<ApiResponse<ConversionRate>> {
    return apiManager.get<ConversionRate>('/api/v1/admin/dollar-conversion-rate');
  }

  async updateDollarConversionRate(data: UpdateConversionRateRequest): Promise<ApiResponse> {
    return apiManager.put('/api/v1/admin/dollar-conversion-rate', data);
  }

  async getGraphConversionRate(): Promise<ApiResponse<{ rate: number }>> {
    return apiManager.get<{ rate: number }>('/api/v1/admin/graph-conversion-rate');
  }
}

export const systemService = new SystemService();